<!-- For Advertiser -->
<template>
  <tr class="popular-account" v-on:click.prevent="trackAdLink(ad)">
    <td>
      <a rel="nofollow">{{ad.account.sectionName}}</a>
    </td>
    <td>
      <a class="apy" rel="nofollow">{{$filters.percentageFilter(ad.account.apy)}}</a>
    </td>
    <td>{{ad.account.name}}</td>
    <td>{{$filters.currencyFormatFilter(ad.account.min)}}</td>
    <td>{{$filters.currencyFormatFilter(ad.account.max)}}</td>
    <td>
      <a class="details-link" rel="nofollow">Details &raquo;</a>
      <img class="tPixel" v-bind:src="$filters.formatTrackingFilter(ad.pixel)">
    </td>
  </tr>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import "../../../utils/filters";
import { adClickMixin } from "../../../mixins/adClickMixin";

export default defineComponent({
  name: "popular-account-advertiser",
  mixins: [adClickMixin],
  props: {
    ad: Object
  }
});
</script>
<style lang="scss" scoped>
.popular-account {
  cursor: pointer;
  &:nth-child(even) {
    background-color: #e9f6fe;
  }
  td {
    border-top: none;
    border-bottom: 1px solid #ddd;
    height: 40px;
    vertical-align: middle;
  }
  td:first-child,
  td:nth-child(3) {
    padding-left: 10px;
    text-align: left;
  }

  .apy {
    font-size: 16px;
    font-weight: bold;
  }

  .details-link {
    color: #f59c00;
    font-size: 14px;
    white-space: nowrap;
  }
}
</style>